import { useEffect, useState } from 'react';
import { Card } from 'primereact/card';
import { Tag } from 'primereact/tag';
import { MonitoreoService } from "../../service/monitoreo/MonitoreoService";
import { ProgressSpinner } from 'primereact/progressspinner';

export const PromedioRiesgo = ({ matrizId, permss, toast, generic, graficoRef, refrescar = 0 }) => {
    const [loading, setLoading] = useState(true);
    const [riesgoInherente, setRiesgoInherente] = useState(0);
    const [riesgoResidual, setRiesgoResidual] = useState(0);
    const matrizSrv = new MonitoreoService();

    useEffect(() => {
        if (matrizId) { consultar(); }
    }, [matrizId, refrescar]);

    const max = 5;

    const consultar = () => {
        setLoading(true);
        matrizSrv.consultar(`${matrizId}`, 'matriz-riesgo/consulta').then(res => {
            const info = res.data;
            setRiesgoInherente(parseFloat(info?.riesgo_inherente_promedio) || 0);
            setRiesgoResidual(parseFloat(info?.riesgo_residual_promedio) || 0);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        }).finally(() => setLoading(false));
    };

    const data = [
        { titulo: 'PROMEDIO NIVEL DE RIESGO INHERENTE', valor: riesgoInherente, controles: 'SIN CONTROLES', icon: 'pi pi-exclamation-triangle' },
        { titulo: 'PROMEDIO NIVEL DE RIESGO RESIDUAL', valor: riesgoResidual, controles: 'APLICANDO CONTROLES', icon: 'pi pi-shield' },
    ];

    const niveles = [
        { nombre: 'Muy Bajo', color: '#00b0f0', umbral: 0.2 },
        { nombre: 'Bajo', color: '#00ff00', umbral: 0.4 },
        { nombre: 'Medio', color: '#ffff00', umbral: 0.6 },
        { nombre: 'Alto', color: '#ffc000', umbral: 0.8 },
        { nombre: 'Muy Alto', color: '#ff0000', umbral: 1 },
    ];

    const getNivel = (valor, max = 5) => {
        const ratio = valor / max;
        for (let nivel of niveles) {
            if (ratio <= nivel.umbral) return nivel;
        }
        return niveles[niveles.length - 1];
    };

    const ColoredProgressBar = ({ valor, max = 5, height = '8px' }) => {
        const nivel = getNivel(valor, max);
        const porcentaje = (valor / max) * 100;
        return (
            <div style={{ width: '100%', backgroundColor: '#e5e7eb', borderRadius: '6px', overflow: 'hidden', height, }}>
                <div style={{ width: `${porcentaje}%`, backgroundColor: nivel.color, height: '100%', transition: 'width 0.3s ease-in-out', }} />
            </div>
        );
    };

    return (
        <>
            {loading ? (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '400px', color: '#444', fontWeight: '500', fontSize: '1.2rem' }}>
                    <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth={5} />
                    <span style={{ marginTop: '1rem' }}>Consultando los promedios...</span>
                </div>
            ) : (
                <div ref={graficoRef} style={{ background: '#f8f9fa', padding: '1rem', overflow: 'hidden' }}>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '1rem', alignItems: 'stretch', marginBottom: '1.5rem' }}>
                        {data.map((item, idx) => {
                            const nivel = getNivel(item.valor, max);
                            return (
                                <Card key={idx} title={
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                        <i className={item.icon} style={{ fontSize: '1.4rem', color: nivel.color }} />
                                        <span style={{ fontWeight: 700 }}>{item.titulo}</span>
                                    </div>
                                } className="p-shadow-4" style={{ width: '100%', borderTop: `4px solid ${nivel.color}`, borderRadius: '12px', background: '#fff' }}>
                                    <p style={{ marginBottom: '0.5rem', color: '#5f6368' }}>{item.controles}</p>
                                    <Tag value={nivel.nombre.toUpperCase()} style={{ backgroundColor: nivel.color, color: '#000', fontWeight: 'bold', marginBottom: '0.5rem' }} />
                                    <div style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '0.75rem' }}>
                                        {item.valor.toFixed(2)}
                                    </div>
                                    <ColoredProgressBar valor={item.valor} max={max} />
                                </Card>
                            );
                        })}
                    </div>
                    {/* Tabla */}
                    <div style={{ width: '100%', background: '#fff', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 6px 15px rgba(0,0,0,0.1)' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.95rem', tableLayout: 'fixed' }}>
                            <thead>
                                <tr style={{ backgroundColor: '#343a40', color: '#fff' }}>
                                    <th style={{ padding: '0.75rem', textAlign: 'left' }}>Descripción</th>
                                    <th style={{ padding: '0.75rem' }}>Valor</th>
                                    <th style={{ padding: '0.75rem' }}>Nivel</th>
                                    <th style={{ padding: '0.75rem' }}>Controles</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((item, idx) => {
                                    const nivel = getNivel(item.valor, max);
                                    return (
                                        <tr key={idx} style={{ backgroundColor: `${nivel.color}1a` }}>
                                            <td style={{ padding: '0.75rem', wordWrap: 'break-word' }}>{item.titulo}</td>
                                            <td style={{ padding: '0.75rem', textAlign: 'center', fontWeight: 'bold' }}>{item.valor.toFixed(2)}</td>
                                            <td style={{ padding: '0.75rem', textAlign: 'center' }}>
                                                <Tag value={nivel.nombre} style={{ backgroundColor: nivel.color, color: '#000', fontWeight: 'bold' }} />
                                            </td>
                                            <td style={{ padding: '0.75rem', textAlign: 'center' }}>{item.controles}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </>
    );
};
